import {
  CreateCategoriesRequest,
  MetafieldSelectedsOrErrorListV2Type,
  MetafieldSelectedsOrErrorType,
  MetafieldSelectedV2Dto,
  ProductDetailsResponseDto,
  ProductImageRequestDto,
  ProductSectionsCodeType,
  TagRequest,
} from '@tiendanube/common';
import ProductMediaRequestDto from '@tiendanube/common/src/domains/catalog/interfaces/ProductMediaRequest';
import { UpdateImagesRequest } from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/ImagesRequest';
import { UpsertMediaRequest } from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/MediaRequest';
import { UpsertMetafieldsRequest } from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/MetafieldsRequest';
import { UpsertSectionsRequest } from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/SectionsRequest';

export function getTags(
  tags: string | undefined,
): { tags: TagRequest[] } | undefined {
  if (!tags) return undefined;
  const tagsToUpsert: TagRequest[] = tags.split(',').map((tag) => ({
    tag: tag.trim(),
  }));
  return { tags: tagsToUpsert };
}

export function getCategories(
  categories: string[] | undefined,
): { categories: CreateCategoriesRequest[] } | undefined {
  if (!categories) return undefined;
  const categoriesToUpsert: CreateCategoriesRequest[] = categories.map(
    (category, index) => ({
      id: Number(category),
      order: index,
    }),
  );
  return { categories: categoriesToUpsert };
}

export function getImages(
  images: ProductImageRequestDto[] | undefined,
): { images: UpdateImagesRequest[] } | undefined {
  if (!images || !images.length) return undefined;
  const imagesToUpsert: UpdateImagesRequest[] = [];
  images.forEach((image, index) => {
    if (image.image_id !== null) {
      imagesToUpsert.push({
        id: Number(image.image_id),
        order: index,
      });
    }
  });
  return { images: imagesToUpsert };
}

export function getMedia(
  media: ProductMediaRequestDto[] | undefined,
): { media: UpsertMediaRequest[] } | undefined {
  if (!media || !media.length) return undefined;
  const mediaToUpsert: UpsertMediaRequest[] = media.map((media, index) => ({
    id: Number(media.id),
    type: media.media_type,
    order: index,
  }));
  return { media: mediaToUpsert };
}

export function getMetafields(
  metafields: MetafieldSelectedsOrErrorListV2Type | undefined,
): { metafields: UpsertMetafieldsRequest[] } | undefined {
  if (
    !metafields ||
    metafields.fromApi === 'error' ||
    metafields.internals === 'error'
  )
    return undefined;

  const metafieldsToUpsert: UpsertMetafieldsRequest[] = [];
  const allMetafields: MetafieldSelectedV2Dto[] = [
    ...metafields.fromApi,
    ...metafields.internals,
  ];

  allMetafields.forEach((metafield) => {
    if (metafield.value) {
      metafieldsToUpsert.push({
        uuid: metafield.id,
        value: metafield.value,
      });
    }
  });
  return { metafields: metafieldsToUpsert };
}

export function getVariantMetafields(
  metafields:
    | MetafieldSelectedsOrErrorListV2Type
    | MetafieldSelectedsOrErrorType
    | undefined,
): { metafields: UpsertMetafieldsRequest[] } | undefined {
  if (!metafields || metafields === 'error') {
    return undefined;
  }

  if ('fromApi' in metafields && 'internals' in metafields) {
    return getMetafields(metafields);
  } else {
    return {
      metafields: metafields.map((metafield) => ({
        uuid: metafield.id,
        value: metafield.selected,
      })),
    };
  }
}

export function getSections(
  sections: ProductSectionsCodeType[] | undefined,
): UpsertSectionsRequest[] | undefined {
  if (!sections) return undefined;
  return sections.map((section) => ({
    id: section,
  }));
}
export function createResponseDto(
  createdId: number,
): ProductDetailsResponseDto {
  return { id: createdId } as unknown as ProductDetailsResponseDto;
}
